let nidHeader = $('.header-holder');

if (!$('body').hasClass('template-index')) {
  nidHeader.addClass('active');
} else {
  nidHeader.hover(
    function () {
      $(this).addClass('active');
    },
    function () {
      $(this).removeClass('active');
    }
  );
}

let closeTimer = null;
  const $items = $('.global-nav-menu .sidebar__menu > li');

  $items.on('mouseenter', function () {
    clearTimeout(closeTimer);

    $items.not(this).removeClass('is-open');

    $(this).addClass('is-open');
  });

  $items.on('mouseleave', function () {
    const $li = $(this);
    closeTimer = setTimeout(function () {
      $li.removeClass('is-open');
    }, 200);
  });

  $('.global-nav-menu .sidebar__submenu').on('mouseenter', function () {
    clearTimeout(closeTimer);
  });

  $('.global-nav-menu .sidebar__submenu').on('mouseleave', function () {
    $(this).closest('li').removeClass('is-open');
  });

  // mobile
  let hamMenuClose = $('.sidebar__close');
  let slideMenu = $('#site-menu-sidebar');
  hamMenuClose.click(function(){
    slideMenu.removeClass('sidebar--opened');
    $('body').removeClass('sidebar-opened');
  });

document.querySelectorAll(
  '.sidebar__menu > li.has-submenu > a'
).forEach(function (a) {

  a.addEventListener('click', function (e) {
    if (window.innerWidth > 1080) return;

    e.preventDefault();

    const li = this.parentElement;

    li.classList.toggle('active');
  });

});

// footer
let footerMenuTitle = $('.footer-item__title');
let footerMenuContent = $('.footer-item--menus .footer-links');

function footerAccordion() {
  if ($(window).width() <= 768) {
    footerMenuContent.slideUp();

    footerMenuTitle
      .off('click')
      .on('click', function () {
        $(this).toggleClass('opened');
        $(this).next().stop().slideToggle();
      });

  } else {
    // PC
    footerMenuTitle.off('click').removeClass('opened');
    footerMenuContent.show().removeAttr('style');
  }
}

footerAccordion();

$(window).on('resize', footerAccordion);
